import * as z from "zod/v4";

// Input schema for Recover analytics
export const GetRecoverAnalyticsInputSchema = z.object({
  startDate: z
    .string()
    .describe("Start date for the analytics period (YYYY-MM-DD)"),
  endDate: z
    .string()
    .describe("End date for the analytics period (YYYY-MM-DD)"),
});

// Schema for a single metric with period comparison
const MetricWithComparisonSchema = z.object({
  value: z.number().describe("Current period value"),
  percentageChange: z
    .number()
    .describe("Percentage change from previous period"),
});

// Schema for daily message data point
const MessageDataPointSchema = z.object({
  date: z.string().describe("Date for this data point (YYYY-MM-DD)"),
  messages: z
    .number()
    .describe("Number of recovery messages sent on this date"),
});

// Output schema for Recover analytics
export const GetRecoverAnalyticsOutputSchema = z.object({
  keyMetrics: z.object({
    recoveryMessages: MetricWithComparisonSchema.describe(
      "Total number of recovery messages sent",
    ),
    lastTouchRevenue: MetricWithComparisonSchema.describe(
      "Revenue from orders where recover discount codes were used",
    ),
    humanRecovered: MetricWithComparisonSchema.describe(
      "Count of discount codes used from recover campaigns",
    ),
    conversations: MetricWithComparisonSchema.describe(
      "Total number of marketing conversations",
    ),
  }),
  messagesSentOverTime: z
    .array(MessageDataPointSchema)
    .describe("Daily breakdown of recovery messages sent"),
});

// Export type definitions for TypeScript
export type GetRecoverAnalyticsInput = z.infer<
  typeof GetRecoverAnalyticsInputSchema
>;
export type GetRecoverAnalyticsOutput = z.infer<
  typeof GetRecoverAnalyticsOutputSchema
>;

// Define the entire schema for RPC usage
export const getRecoverAnalytics = {
  name: "getRecoverAnalytics" as const,
  input: GetRecoverAnalyticsInputSchema,
  output: GetRecoverAnalyticsOutputSchema,
  mock: {
    keyMetrics: {
      recoveryMessages: { value: 142, percentageChange: 12.5 },
      lastTouchRevenue: { value: 8540.0, percentageChange: 8.3 },
      humanRecovered: { value: 37, percentageChange: -2.1 },
      conversations: { value: 215, percentageChange: 15.0 },
    },
    messagesSentOverTime: [
      { date: "2026-03-08", messages: 5 },
      { date: "2026-03-15", messages: 8 },
      { date: "2026-03-22", messages: 12 },
      { date: "2026-03-29", messages: 7 },
      { date: "2026-04-05", messages: 10 },
    ],
  },
};
